// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__5r66i","loading":"Skeleton_loading__rv977","wrapper":"Skeleton_wrapper__KY8KJ","show":"Skeleton_show__wL69o"};